import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { OrderService } from 'src/app/service/order.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  constructor(public authService: AuthService, private orderService: OrderService
  ) { }

  passwordVisible: boolean = false;
  countries: any[];

  ngOnInit(): void {
    this.orderService.getCountries().then((ca: []) => {
      this.countries = ca;
    }, err => {
      console.log(err)
    } // Show error
    )
  }
}
